import { css } from '@emotion/css';

type BlurIntensity = 'light' | 'medium' | 'strong';

const commonBlurStyles = {
  pointerEvents: 'none' as const,
  userSelect: 'none' as const,
};

export const BLUR_STYLES: Record<BlurIntensity, string> = {
  light: css({
    ...commonBlurStyles,
    filter: 'blur(1px)',
  }),
  medium: css({
    ...commonBlurStyles,
    filter: 'blur(1.5px)',
  }),
  strong: css({
    ...commonBlurStyles,
    filter: 'blur(2px)',
  }),
};
